import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { IconButton } from '@hbf/dsl';
import { ChevronLeftIcon, ChevronRightIcon } from 'ha/ui/Icons';
import { ControlProps } from 'ha/components/Slider';

export const useStyles = makeStyles()({
  root: {
    boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.11)',
  },
});

interface Props {
  direction: 'left' | 'right';
  onClick?: () => void;
}

export const SliderControl: React.FC<Props & ControlProps> = ({
  onClick,
  direction,
}) => {
  const { classes } = useStyles();
  const isLeft = direction === 'left';

  return (
    <IconButton
      className={classes.root}
      onClick={onClick}
      size="large"
      data-test-locator={`SliderControl Icon - ${isLeft ? 'Left' : 'Right'}`}
    >
      {isLeft ? (
        <ChevronLeftIcon color="secondary" />
      ) : (
        <ChevronRightIcon color="secondary" />
      )}
    </IconButton>
  );
};
